import { Admin } from '@models/Admin'
import { useAuth } from '@modules/auth/contexts/Auth'
import {
  FeatureFlag,
  useFeature,
  useFeatureFlagsSettled,
} from '@utils/featureFlags'
import { Flex, Spin } from 'antd'
import { PropsWithChildren } from 'react'
import { Navigate } from 'react-router-dom'

interface Props {
  flag: FeatureFlag
  /** Where an admin without the feature is sent, as an unknown path would be */
  redirectTo: string
}

/**
 * A route element shown only while its feature runs. The route itself stays
 * declared, so a deep link waits for the flags instead of being redirected
 * while they are still on their fallback. The wait can last up to the
 * Datadog timeout, so it shows a loader rather than a blank page.
 */
const FeatureRoute = ({
  flag,
  redirectTo,
  children,
}: PropsWithChildren<Props>) => {
  const { currentUser } = useAuth<Admin, {}>()
  const { enabled } = useFeature(flag)
  const settled = useFeatureFlagsSettled(currentUser)

  if (enabled) return <>{children}</>
  if (!settled)
    return (
      <Flex
        justify="center"
        align="center"
        className="w-full"
        style={{ minHeight: 200 }}
      >
        <Spin />
      </Flex>
    )
  return <Navigate to={redirectTo} replace />
}

export default FeatureRoute
